import * as React from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { GridMoreVertIcon } from '@mui/x-data-grid';
import { Close as CloseIcon, DeleteOutlined as DeleteIcon, Done as DoneIcon, BorderColorOutlined as EditIcon, FileUploadOutlined as FileUploadOutlinedIcon } from '@mui/icons-material';
import { ContextStore } from '../store/contextStore';
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';

const useStyles = makeStyles((theme) => ({
  menu: {
    "& .MuiPaper-root": {
      borderRadius: 8,
    },
  },
  menuItemIcon: {
    marginRight: 8,
  },
}));

/**
 * Bulk actions menu for itinerary toolbar
 * @param props
 * @param {string[]} props.selectedIds
 * @param {boolean} props.isSmallScreen
 * @param {function} props.onPublishItinerary
 * @param {function} props.onUnpublishItinerary
 * @param {function} props.onDeleteItinerary
 * @param {function} props.onChangeDisplaySettings
 * @return {Element}
 * @constructor
 */
const BulkActionsMenu = (props) => {
  const [open, setOpen] = React.useState(false);
  const { hasPerm } = React.useContext(ContextStore);
  const buttonRef = React.useRef(null);
  const classes = useStyles();

  const onBulkActionsClick = (ev) => setOpen(true);
  const handleClose = () => setOpen(false);

  const menuItems = [];

  if (hasPerm('itinerary', 'write')) {
    menuItems.push(
      <MenuItem key={'publishBt'} onClick={props?.onPublishItinerary}>
        <DoneIcon color='primary' className={classes.menuItemIcon} />
        Publish itineraries
      </MenuItem>
    );
    menuItems.push(<Divider component="li" />);
    menuItems.push(
      <MenuItem key={'unpublishBt'} onClick={props?.onUnpublishItinerary}>
        <CloseIcon color='primary' className={classes.menuItemIcon} />
        Unpublish itineraries
      </MenuItem>
    );
    menuItems.push(<Divider component="li" />);
    menuItems.push(
      <MenuItem key={'changeDisplaySettingsBt'} onClick={props?.onChangeDisplaySettings}>
        <EditIcon color='primary' className={classes.menuItemIcon} />
        Edit display settings
      </MenuItem>
    );
  }

  if (hasPerm('itinerary', 'export') && props?.onDocumentExport) {
    menuItems.push(<Divider component="li" />);
    menuItems.push(
      <MenuItem key={'exportBt'} onClick={props?.onDocumentExport}>
        <FileUploadOutlinedIcon color='primary' className={classes.menuItemIcon} />
        Export as XML / JSON
      </MenuItem>
    );
  }

  // CP-5545: without the delete permission the entry is disabled (grey), not dropped — unless the menu has
  // nothing else to offer, in which case the whole menu stays hidden.
  const canDelete = hasPerm('itinerary', 'delete');
  if (canDelete || menuItems.length > 0) {
    menuItems.push(<Divider component="li" />);
    menuItems.push(
      <MenuItem key={'deleteBt'} onClick={props?.onDeleteItinerary} disabled={!canDelete}>
        <DeleteIcon color={canDelete ? 'error' : 'inherit'} className={classes.menuItemIcon} />
        <Typography color={canDelete ? 'error' : 'inherit'}>Delete itineraries</Typography>
      </MenuItem>
    );
  }


  return menuItems.length === 0 ? null : (
    <Box direction="row-reverse">
      <Button
        ref={buttonRef}
        color="info"
        variant="outlined"
        size={props.isSmallScreen ? 'normal' : 'small'}
        onClick={onBulkActionsClick}
      >
        <GridMoreVertIcon />
        &nbsp;{!props.isSmallScreen ? 'Bulk actions' : null}
      </Button>

      <Menu
        className={classes.menu}
        anchorEl={buttonRef.current}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{

        }}
      >
        {menuItems}
      </Menu>
    </Box>
  );
};

export default BulkActionsMenu;
